import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  copyToClipboard: {
    id: 'studio.Zhw6Jx',
    defaultMessage: 'Clipboard',
  },
  shareSuccess: {
    id: 'studio.LRoQwS',
    defaultMessage: 'Successfully copied link to the clipboard',
  },
});
